@if (isRmbRmc) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
}
<p class="person-label">{{ selectedIndividual | fullname }}</p>
<nh-form
  [topLevelName]="'ut'"
  [individuals]="checkForDropdown ? finalListIndvs : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  topLevelQuestion="{{ 'UTILITIES_EXPENSES_STATIC_TEXT1' | globalTranslate }}"
  popupText="{{ 'UTILITIES_EXPENSES_STATIC_TEXT2' | globalTranslate }}"
  [individualQuestion]="'UTILITIES_EXPENSES_STATIC_TEXT3' | globalTranslate"
  [hintText]="hintText"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "UTILITIES_EXPENSES_STATIC_TEXT4" | globalTranslate }}
    </h1>
    <hr />
    <nh-field
      id="ut_housingTypeExpense"
      label="{{ 'UTILITIES_EXPENSES_STATIC_TEXT5' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'UTILITIES_EXPENSES_STATIC_TEXT6' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="housingTypeExpense"
        [items]="
          tableCodeValue('SHELTERUTILITYEXPTYPE', 'data.housingTypeExpense')
        "
        [attr.disabled]="isHousingTypeExpenseDisabled"
        [attr.aria-labelledby]="'ut_housingTypeExpense'"
        formControlName="housingTypeExpense"
        required
      ></select>
    </nh-field>
    <div [formGroup]="getControl('data.expensePaymentInformation')">
      <nh-field
        id="ut_expenseFrequencyCode"
        label="{{ 'UTILITIES_EXPENSES_STATIC_TEXT7' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'UTILITIES_EXPENSES_STATIC_TEXT8' | globalTranslate }} "
        class="label-section"
      >
        <select
          nhTranslate
          name="expenseFrequencyCode"
          [attr.aria-labelledby]="'ut_expenseFrequencyCode'"
          [items]="
            tableCodeValue(
              'INCEXPPAYFREQUENCY',
              'data.expensePaymentInformation.expenseFrequencyCode'
            )
          "
          formControlName="expenseFrequencyCode"
          required
        ></select>
      </nh-field>

      <nh-field
        id="ut_expenseAmount"
        label="{{ 'UTILITIES_EXPENSES_STATIC_TEXT9' | globalTranslate }}"
        class="label-section"
      >
        <nh-input-group prepend="$">
          <input
            nh
            type="decimal"
            [attr.aria-labelledby]="'ut_expenseAmount'"
            maxlength="7"
            name="expenseAmount"
            formControlName="expenseAmount"
            class="form-control"
            required
          />
        </nh-input-group>
      </nh-field>
    </div>
  </section>
</nh-form>